import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { Checkbox as AriaCheckbox, Text as AriaText } from "react-aria-components";
import { Minus } from "../icons/line.js";
import { Check } from "../icons/solid.js";
import { base, checkbox, supportTextClass, textContent, textWrapper, wrapper } from "./Checkbox.css.js";

// this is used make sure the checkbox is always the same size, regardless of `selected` state
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const NoIcon = t0 => {
  const $ = _c(2);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = /*#__PURE__*/_jsx("svg", {
      className: className,
      width: 24,
      height: 24,
      fill: "none",
      viewBox: "0 0 24 24"
    });
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const Text = t0 => {
  const $ = _c(12);
  const {
    supportingText,
    children,
    size
  } = t0;
  const t1 = supportingText == null ? textWrapper : undefined;
  let t2;
  if ($[0] !== size) {
    t2 = textContent({
      size
    });
    $[0] = size;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== t2) {
    t3 = /*#__PURE__*/_jsx("div", {
      className: t2,
      children: children
    });
    $[2] = children;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== size || $[6] !== supportingText) {
    t4 = supportingText == null ? null : /*#__PURE__*/_jsx("div", {
      className: supportTextClass({
        size
      }),
      children: supportingText
    });
    $[5] = size;
    $[6] = supportingText;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t3 || $[10] !== t4) {
    t5 = /*#__PURE__*/_jsxs(AriaText, {
      className: t1,
      children: [t3, t4]
    });
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
const CheckboxIcon = t0 => {
  const $ = _c(12);
  const {
    isSelected,
    isIndeterminate,
    size
  } = t0;
  if (isIndeterminate === true) {
    let t1;
    if ($[0] !== size) {
      t1 = checkbox({
        size
      });
      $[0] = size;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t1) {
      t2 = /*#__PURE__*/_jsx(Minus, {
        className: t1
      });
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  if (isSelected === true) {
    let t1;
    if ($[4] !== size) {
      t1 = checkbox({
        size
      });
      $[4] = size;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    let t2;
    if ($[6] !== t1) {
      t2 = /*#__PURE__*/_jsx(Check, {
        className: t1
      });
      $[6] = t1;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    return t2;
  }
  let t1;
  if ($[8] !== size) {
    t1 = checkbox({
      size
    });
    $[8] = size;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== t1) {
    t2 = /*#__PURE__*/_jsx(NoIcon, {
      className: t1
    });
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};
const BaseCheckbox = (t0, ref) => {
  const $ = _c(18);
  let children;
  let props;
  let supportingText;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      children,
      supportingText,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = supportingText;
    $[4] = t1;
  } else {
    children = $[1];
    props = $[2];
    supportingText = $[3];
    t1 = $[4];
  }
  const size = t1 === undefined ? "m" : t1;
  let propsWithoutType;
  if ($[5] !== props) {
    const {
      type: _type,
      ...t2
    } = props;
    propsWithoutType = t2;
    $[5] = props;
    $[6] = propsWithoutType;
  } else {
    propsWithoutType = $[6];
  }
  let t2;
  if ($[7] !== size) {
    t2 = wrapper({
      size
    });
    $[7] = size;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== children || $[10] !== size || $[11] !== supportingText) {
    t3 = t4 => {
      const {
        isIndeterminate,
        isSelected
      } = t4;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: base({
            size
          }),
          children: /*#__PURE__*/_jsx(CheckboxIcon, {
            isSelected: isSelected,
            isIndeterminate: isIndeterminate,
            size: size
          })
        }), children == null ? null : /*#__PURE__*/_jsx(Text, {
          supportingText: supportingText,
          size: size,
          children: children
        })]
      });
    };
    $[9] = children;
    $[10] = size;
    $[11] = supportingText;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== propsWithoutType || $[14] !== ref || $[15] !== t2 || $[16] !== t3) {
    t4 = /*#__PURE__*/_jsx(AriaCheckbox, {
      ref: ref,
      ...propsWithoutType,
      className: t2,
      children: t3
    });
    $[13] = propsWithoutType;
    $[14] = ref;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
};
export const Checkbox = /*#__PURE__*/React.forwardRef(BaseCheckbox);
//# sourceMappingURL=Checkbox.js.map